import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Grid,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import authService from "../../services/auth";

function TaxasLicenciamento() {
  const [porte, setPorte] = useState("pequeno");
  const [potencial, setPotencial] = useState("baixo");
  const [taxas, setTaxas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const carregarTaxas = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get("TaxasDeTipoLicenca/GetAll");
      setTaxas(response.data || []);
    } catch (err) {
      console.error("Erro ao carregar taxas:", err);
      if (err.response?.status === 403) {
        setError("Acesso negado. Apenas analistas podem acessar as taxas de licenciamento.");
      } else {
        setError("Erro ao carregar taxas de licenciamento");
      }
      setTaxas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = authService.getCurrentUser();
    if (!user || !user.data.isAnalista) {
      setError("Acesso restrito. Apenas analistas podem acessar este recurso.");
      return;
    }
    carregarTaxas();
  }, []);

  const calcularValor = (taxa) => {
    let valor = taxa.valorInicial;

    if (porte === "medio") {
      valor += taxa.valorAdicionalPorteMedio;
    } else if (porte === "grande") {
      valor += taxa.valorAdicionalPorteGrande;
    }

    if (potencial === "medio") {
      valor += taxa.valorAdicionalPotencialMedio;
    } else if (potencial === "alto") {
      valor += taxa.valorAdicionalPotencialGrande;
    }

    return valor;
  };

  return (
    <Container sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ mt: { xs: 2, md: 4 }, mb: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.125rem" } }}
        >
          Taxas de Licenciamento
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          Simule o valor das taxas de licenciamento com base no porte do
          empreendimento e seu potencial poluidor/degradador.
        </Alert>

        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
          <Grid container spacing={{ xs: 2, md: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Porte do Empreendimento"
                value={porte}
                onChange={(e) => setPorte(e.target.value)}
              >
                <MenuItem value="pequeno">Pequeno</MenuItem>
                <MenuItem value="medio">Médio</MenuItem>
                <MenuItem value="grande">Grande</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                fullWidth
                label="Potencial Poluidor/Degradador"
                value={potencial}
                onChange={(e) => setPotencial(e.target.value)}
              >
                <MenuItem value="baixo">Baixo</MenuItem>
                <MenuItem value="medio">Médio</MenuItem>
                <MenuItem value="alto">Alto</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </Paper>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
          <Table>
            <TableHead sx={{ bgcolor: "action.hover" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", minWidth: 200 }}>
                  Tipo de Licença
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold", minWidth: 140 }}>
                  Valor (R$)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : taxas.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                    Nenhuma taxa de licenciamento encontrada
                  </TableCell>
                </TableRow>
              ) : (
                taxas.map((taxa) => (
                  <TableRow key={taxa.tipoLicencaId}>
                    <TableCell>{taxa.tipoLicencaNome}</TableCell>
                    <TableCell align="right">
                      {calcularValor(taxa).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
}

export default TaxasLicenciamento;
